module.exports = __webpack_public_path__ + "src/assets/sl.aceead1a.png";